export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11440.64d3e2c8.jpg";